const attributes = {
  // Additives
  consume: { name: "consume", default: {}, isAdditive: true },
  resilience: { name: "resilience", default: {}, isAdditive: true },
  startBonus: {
    name: "startBonus",
    default: { ammo: 0, coins: 0, food: 0 },
    isAdditive: true,
  },

  // Multipliers
  craftsmanship: {
    name: "craftsmanship",
    default: { craftsmanship: 1 },
    isAdditive: false,
  },
  luck: { name: "luck", default: { luck: 1 }, isAdditive: false },
  charisma: { name: "charisma", default: { charisma: 1 }, isAdditive: false },
};

export default attributes;
